// Imports
import React from "react";
import startScreenResponsive from "src/files/quiz-screen-start-responsive.svg";
import closeCross from "src/files/cross.svg";
import { useQuiz } from "src/contexts/QuizContext.js";
import FocusTrap from "focus-trap-react";
import QuizScreenHowItWorks from "src/modules/QuizScreenHowItWorks/jsx/index.jsx";
import { quizInteractionTracking } from "src/modules/QuizHelpers/index.js";
function QuizScreenStart() {
    const { dispatch, quizStatus } = useQuiz();

    return (
        <FocusTrap
            active={quizStatus === "start"}
            focusTrapOptions={{
                initialFocus: false,
            }}
        >
            <div
                className={`quiz-screen-start ${quizStatus !== "start" ? `quiz--started` : ``}`}
            >
                <button
                    onClick={() => {
                        window.location.href = window.config?.baseUrl ?? "#";
                    }}
                    className="quiz-screen-start__close-button"
                    tabIndex={!quizStatus !== "summary" ? 0 : -1}
                >
                    <span>Cancel</span>
                    <img
                        className="quiz-screen-start__icon-cross"
                        src={closeCross}
                        alt=""
                    />
                </button>
                <div className="quiz-screen-start__container">
                    <div className="quiz-screen-start__landing-body">
                        <h2 className="quiz-screen-start__title">
                            Welcome to the Senior Road User Quiz
                        </h2>
                        <p className="quiz-screen-start__subtitle">
                            Check-in and stay informed with road safety
                            information tailored to you.
                        </p>
                        <div className="quiz-screen-start__decoration">
                            <img
                                className="quiz-screen-start__decoration-image decoration--responsive"
                                src={startScreenResponsive}
                                alt=""
                            />
                        </div>
                        <div className="quiz-screen-start__button-group">
                            <button
                                className="button button--large"
                                tabIndex={quizStatus !== "start" ? -1 : 1}
                                onClick={(e) => {
                                    e.preventDefault();
                                    // Start Quiz
                                    quizInteractionTracking({
                                        interaction_type: "click",
                                        question_number: null,
                                        sub_question_index: null,
                                        selected_answer_index: null,
                                        answer_changed: false,
                                        navigation_action: "start",
                                    });
                                    dispatch({
                                        type: "resetQuiz",
                                    });
                                }}
                            >
                                Start the quiz
                            </button>
                            <a
                                className="button button--large"
                                target="_self"
                                href={window?.config?.infoHubUrl ?? "#"}
                                tabIndex={quizStatus !== "start" ? -1 : 1}
                            >
                                Explore Resources
                            </a>
                            <QuizScreenHowItWorks />
                            <span className="quiz-screen-start__disclaimer">
                                We take your privacy seriously. All information
                                gathered is anonymous and confidential.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </FocusTrap>
    );
}

export default QuizScreenStart;
